import { render, staticRenderFns } from "./FarmerAgentDisplay.vue?vue&type=template&id=442f8b4d&scoped=true&"
import script from "./FarmerAgentDisplay.vue?vue&type=script&lang=js&"
export * from "./FarmerAgentDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442f8b4d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
